import React, { useEffect, useState } from "react";
import fnc from "../mymod/commFunction";
import fncSql from "../mymod/commFunctionSql";
import { useNavigate } from "react-router-dom";
import './Assess_link_stu.scss';
import { useSelector, useDispatch } from "react-redux";
import * as S from '../scss/theme';
import  HongButton from '../comm/HongButton';
// import HongButton from '@mui/material/Button';
import imgReport from '../images/svg/report.svg';
import imgCheckList from '../images/svg/checklist.svg';
import imgLink from '../images/svg/link.svg';
import HeaderTitle from "../comm/HeaderTitle";
import Assess_all_checkList from "./Assess_all_checkList";
import { setSelectedTestCode } from "../reduxToolkit/reduxIgong";

const Assess_link_stu = () => {
    const svrUrl = process.env.REACT_APP_SERVER_URL;
    const {orgCode, stCode: parentCode} = useSelector((state) => state.reduxIgong.userInfo);
   
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [stCode, setStCode] = useState(null);
    const [userKind2, setUserKind2] = useState(null);
    const [userId, setUserId] = useState(null);
    const [userHp, setUserHp] = useState(null);
    const [userName, setUserName] = useState(null);
    const [isRefresh, setIsRefresh] = useState(false);

    const [selectedSno, setSelectedSno] = useState(null);
    const [kwamokList, setKwamokList] = useState([]);
    const [selectedKwamokObj, setSelectedKwamokObj] = useState({});
    const [isModal_result, setIsModal_result] = useState(false);

    const [list, setList] = useState([]);
    const [title, setTitle] = useState('');
    const [testCode, setTestCode] = useState(null);

    // console.log(userInfo, 'userInfo');

    useEffect(() => {
        fncSelect_list();
        setTitle(`학생용 | 코칭진단`);
    }, [isRefresh]);
    
            
  
  function fncSelect_list() {
    
    fnc.sendAxios('/igongAssess_linkRoutes/select/aca_stu', { orgCode, parentCode }, (res) => {
      if (res && Array.isArray(res)) { 
        const newList = getRecords(res);
        setList(newList);
      } else {
        alert('검색에 실패했습니다.');
      }
    });
  }

  
  
  function getRecords(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) { 
        const sno = res[i]["sno"];  
        const orgCode = res[i]["orgCode"];
        const stCode = res[i]["stCode"];
        const userHp = res[i]["userHp"];
        const userId = res[i]["userId"];
        const userName = res[i]["userName"];
        const userKind = res[i]["userKind"];
        const userKind2 = res[i]["userKind2"];
        let sDate = res[i]["sDate"];
        sDate = fnc.formatDate2(sDate); 
        let eDate = res[i]["eDate"];
        eDate = fnc.formatDate2(eDate);    
        records.push({ sno, orgCode, stCode, userHp, userId, userName, userKind, userKind2, sDate, eDate });
    }
    return records;
  }

    
  
  function onClickTr( item, index) {


    // setSelectedSno(item.sno);
    // setUserId(item.userId);
    // setUserHp(item.userHp);
    // setUserName(item.userName);
    // setSelectedKwamokObj({ value: item.kwamokCode, label: item.kwamok });
    // setStCode(item.stCode);
  }


  function onClickLink(item) {

    // const baseUrl = window.location.origin; // ex. http://localhost:3000
    // const link = `${baseUrl}/igongAssess_linkRoutes/enter?stCode=${item.stCode}&kind=${item.userKind2}`;
    const stCode = item.stCode;
    const userKind = item.userKind;

    let link;
    fnc.sendAxios('/igongAssess_linkRoutes/gen-link', { svrUrl, stCode, userKind }, (res) => {
      if (res) { 
        link = res.link;
        navigator.clipboard.writeText(link)
        .then(() => {
          alert('진단평가 링크가 클립보드에 복사되었습니다!');
        })
        .catch(err => {
          alert('클립보드 복사에 실패했습니다.');
          console.error('Copy error:', err);
        });

    } else {
      alert('링크 생성에 실패했습니다.');
    }
  });
  }

  function onClickCheckList(item) {
    console.log(item, 'item Click');
    setTestCode(item.testCode);
    setStCode(item.stCode);
    setIsModal_result(true);

  }
  

  function onClickReport(item) {

  }
  
  function onClickTestNmSt(item) {

    // dispatch(setSelectedStCode(item.stCode));
    // dispatch(setSelectedUserName(item.userName));

    fncSql.getUserInfo(dispatch, item.stCode, () => {
      navigate('/assess/all/testNmApp');
    });


  }

    //==================================================================================
    return (
        <S.Section>
        <HeaderTitle  title={title} direction={1} onBackClick={() => navigate(-1)} />
           
        <div className="Assess_link_stu">
        <section className='sec-main'>
                    <table className="table-hong table-main">
                    <thead>
                        <tr>
                        <th>No</th>                      
                        <th>이름</th>
                        <th>핸드폰</th>    
                        <th>가입일</th>
                        {/* <th>링크</th> */}
                        <th>선택</th>
           
                        </tr>
                    </thead>

                    <tbody>
                        {list && list.map((item, index) => (
        
                            <tr key={index} onClick={() => onClickTr(item, index)}
                                className={selectedSno === item.sno ? 'selected' : ''}>  
                                <td>{index+1}</td>
                                <td>{item.userName}</td>
                                <td>{item.userHp}</td>   
                                <td>{item.sDate}</td>

                                {/* <td>
                                    <HongButton 
                                        className="btnReport"  
                                        onClick={() => onClickLink(item)}
                                        startIcon={<img src={imgLink} alt="링크" />}
                                    >
                                    </HongButton>
                                </td> */}

                                <td>
                                    <HongButton 
                                        className="btnReport h-btn-green"  
                                        onClick={() => onClickTestNmSt(item)}
                                      
                                    >
                                      선택
                                    </HongButton>
                                </td>

                            </tr>
                        ))}
                    
                        </tbody>

                    </table>

                </section> 

            
                </div>

                {isModal_result && (
                    <S.Modal>
                        <HeaderTitle  title={title} direction={1} onBackClick={() => setIsModal_result(false)} />
                        <section className="">
                                <Assess_all_checkList testCode={testCode} stCode={stCode}/>
                        </section>              
                    </S.Modal>
                 )}

        </S.Section>
    );
};

export default Assess_link_stu;
